<template>
  <LoginComponent/>
</template>

<script>
  import LoginComponent from '../components/LoginComponent'
  import { mapMutations } from 'vuex';

  export default {
    data() {
        return {
             mockAccount: {
                    username: "msoma",
                    password: "password"
                }
        }
    },
    methods: {
        ...mapMutations([
            'setAuthenticated',
            'setLoggedInUser'
        ]),
        doLogout() {
            this.setAuthenticated( false );
            this.setLoggedInUser( '' );
        }
    },
    components: {
      LoginComponent
    },
    beforeMount () {
        this.doLogout()
    }
  }
</script>